





















































































































































import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { colorClassByDelivered } from "@/utils/page-utils";
import WhatsappGroupFilter from "@/components/Whatsapp/Statistic/WhatsappGroupFilter.vue";
import { WhatsappGroupItem } from "@/store/whatsapp/statistic/types";
import GroupCharts from "@/components/Statistics/GroupCharts.vue";

@Component({
  components: {WhatsappGroupFilter, ScrollButton, GroupCharts},
  methods: {colorClassByDelivered},
})
export default class WhatsappGroup extends BaseItemsPage<WhatsappGroupItem> {

  @Getter("whatsappStatisticGroup") responseItems!: WhatsappGroupItem[];

  is_show_filter = true;
  is_show_graphics = true;

  currentSort = "date";
  currentSortOrder = "asc";

  tableFields = this.tableFieldsDefault;

  group_by = '';
  optionally_group_by = '';

  getFieldName(name: string) {
    if (name == 'total') return 'total'
    if (name == 'partner_price') return 'income'
    if (name == 'provider_price') return 'rate'
    return name
  }

  onGroupByChange(data: any) {
    this.group_by = data.groupBy
    this.optionally_group_by = data.optionallyGroupBy
  }

  print(item: string, totalRow: boolean) {
    if (totalRow) return this.group_by ? '' : this.$t('inAll');
    return item ?? this.$t('unnamed')
  }

  getData(): WhatsappGroupItem[] {
    return this.responseItems;
  }

  get tableFieldsDefault() {
    let isShowFinInf: boolean = localStorage.getItem("show-finance-info") === "true";
    let priceFields = ["partner_price", "provider_price"];
    return [
      ...["delivered", "read", "not_delivered", "transmitted", "expired", "failed", "rejected", "deferred", "total"],
      ...(isShowFinInf ? priceFields : []),
    ];
  }

  get totalData(): WhatsappGroupItem {
    let total = {
      totalRow: "This is the last row of the table",
      delivered: 0,
      read: 0,
      not_delivered: 0,
      transmitted: 0,
      expired: 0,
      failed: 0,
      rejected: 0,
      deferred: 0,
      total: 0,
      partner_price: "0",
      provider_price: "0",
    };
    this.tableData.forEach( (row: WhatsappGroupItem) => {
      total.delivered += row.delivered;
      total.read += row.read;
      total.not_delivered += row.not_delivered;
      total.transmitted += row.transmitted;
      total.expired += row.expired;
      total.failed += row.failed;
      total.rejected += row.rejected;
      total.deferred += row.deferred;
      total.total += row.total;
      total.partner_price = String((Number(row.partner_price) + Number(total.partner_price)).toFixed(4));
      total.provider_price = String((Number(row.provider_price) + Number(total.provider_price)).toFixed(4));
    });
    return total;
  }

  get compareData() {
    return [...this.queriedData, this.totalData];
  }
}
